import { Component, Input } from '@angular/core';
import { CommonModule, NgForOf, NgIf } from '@angular/common';

@Component({
    selector: 'lib-alert-banner',
    standalone: true,
    imports: [
        CommonModule,
        NgForOf,
        NgIf
    ],
    templateUrl: './alert-banner.component.html',
    styleUrl: './alert-banner.component.scss'
})
export class AlertBannerComponent {

    hiddenClass = 'd-none';

    /**
     * Alert type represents the type of alert. It will be concatenated with the string `mm-alert-`
     * If type is "error", that would add the class `mm-alert-error` to the parent
     */
    @Input() alertType = '';

    /**
     * Max width allowed for the alert card to be displayed
     */
    @Input() maxWidth: number | string = '';

    /**
     * Whether this alert is hidden.
     * @param hidden true if hidden, otherwise false.
     */
    @Input() set hidden(hidden: boolean) {
        this.hiddenClass = hidden ? 'd-none' : '';
    }

    @Input() message?: string;

    @Input() messageList?: string[];
}
